import type { AdobeDataLayerEvent } from '@/contexts/analytics/utils/types';

declare global {
  interface Window {
    adobeDataLayer: unknown[];
  }
}

export const initializeAdobeDataLayer = (): void => {
  if (typeof window !== 'undefined' && !window.adobeDataLayer) {
    window.adobeDataLayer = [];
  }
};

export const pushToAdobeDataLayer = (data: AdobeDataLayerEvent): void => {
  if (typeof window !== 'undefined' && window.adobeDataLayer) {
    window.adobeDataLayer.push(data);
  }
};

export const sanitizeValue = <T>(value: T | null | undefined | ''): T | undefined => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  return value;
};
